import store from "@/store/index.js";

const eventManage = store.getters.eventManage;
const isAuth = store.getters.isAuthenticated;

const checkForLockedMatches = (matchId, league_id, lockedMatchIds, lockedLeagueIds) => {
    return isAuth && (lockedMatchIds.length || lockedLeagueIds.length) ? !lockedMatchIds.includes(parseInt(matchId)) && !lockedLeagueIds.includes(parseInt(league_id)) : true
};

const checkEventManageforSingleType = (type) => {
    if(isAuth) {
        let sportEventManage = eventManage.find(item => item.type == type);
        if(type == 'worli-matka' && sportEventManage && sportEventManage.type_id != null ) {
            return true
        }
        return !sportEventManage;
    }
    return true;    
};

const checkEventManageForMatka = (id = null) => {
    if(isAuth) {
        let matkaEventManageId = eventManage.filter(item => item.type == 'worli-matka').map(evm => evm.type_id);
        return !matkaEventManageId.includes(id);
    }
    return true;
};

const checkForPremiumFancyEvent = () => {
    if (isAuth && eventManage) {
        let sportEventManage = eventManage.find(item => item.type == 'premium-fancy');
        return !sportEventManage
    }
    return true;
};

const checkEventManageforSports = (sportId) => {
    if (isAuth) {
        let sportEventManage = eventManage.filter(item => item.type == 'sports');
        if (sportEventManage.length) {
            for(let i = 0; i < sportEventManage.length; i++){
                if(sportEventManage[i].type_id == sportId) {
                    return false;
                }
            }
        }
    }
    return true;
};

const checkInEventMangeForSection = (gamesData) => {
    try {
        let LockedProvider = eventManage?.filter(item => item.type == 'casino-provider').map(lp => lp.type_id);
        let LockedProviderGames = eventManage?.filter(item => item.type == 'provider-game').map(lpg => lpg.type_id);;
    
        let lockCondition = (typeId, gameCode, LockedProvider, LockedProviderGames) => { 
            return (LockedProvider.length || LockedProviderGames.length) ? !(LockedProviderGames.includes(gameCode)) && !(LockedProvider.includes(typeId)) :true;
        }

        for(let key in gamesData) {
            let item = gamesData[key];
            if(item?.menus?.length) {
                item.menus.forEach(mItem => {
                    mItem.games = mItem.games.filter(menuGame => lockCondition(menuGame.provider_id,menuGame.id, LockedProvider, LockedProviderGames)) 
                })
                item.menus = item.menus.filter(menuItems => menuItems.games.length > 0);
            } else if(item?.games?.length) {
                item.games = item.games.filter(gItem => lockCondition(gItem.provider_id,gItem.id, LockedProvider, LockedProviderGames)) 
            }
        }
    } catch (e) {
        return gamesData;
    }
};

const CheckEventMangeForCasinoInSearch = (gamesData) => {
    try {
        let LockedProvider = eventManage?.find(item => item.type == 'casino-provider');
        let LockedProviderGames = eventManage?.find(item => item.type == 'provider-game');
        LockedProvider = LockedProvider && LockedProvider.type_id !== null ? LockedProvider.type_id.split(',') : [];
        LockedProviderGames = LockedProviderGames && LockedProviderGames.type_id !== null ? LockedProviderGames.type_id.split(',') : [];        
        return  gamesData?.filter((item) => !LockedProvider.includes(item?.provider_id.toString()) && !LockedProviderGames.includes(item?.id.toString()));
    } catch (e) {
        return gamesData;
    }
};

export {
    checkForLockedMatches,
    checkEventManageforSports,
    checkInEventMangeForSection,
    checkForPremiumFancyEvent,
    checkEventManageforSingleType,
    checkEventManageForMatka,
    CheckEventMangeForCasinoInSearch
}
